import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { ExternalLink } from './ExternalLink';

interface ForumProps {
  variant: 'footer' | 'header' | 'subitem';
}

export const Forum = ({ variant }: ForumProps) => (
  <ExternalLink variant={variant} href="https://forum.fiverr.com/c/fiverr-affiliates" category={'Forum'}>
    <I18n k="affiliates_signup_perseus.community.forum" />
  </ExternalLink>
);
